import { Component, ElementRef, ChangeDetectorRef, SimpleChanges, OnChanges } from "@angular/core";
import { Broadcaster } from "../service/Broadcaster";
import { SingService } from "../service/sing.service";
import { AddCampaign } from "./service/add-campaign.service";
import { ChangeSumm } from "./class/ChangeSumm";
import { SummExpense } from "./class/summ-expense";
import { Expense } from "../class/expense/expense";
import { responseUpdateExpensesProduct } from "../class/http/res/response-update-expenses-product";
import { responseRemoveExpense } from "../class/http/res/response-remove-expense";
import { responseSaveExpense } from "../class/http/res/response-save-expense";
import {  responseAddExpense } from "../class/http/res/response-add-expense";
import { showAddCampaignMode } from "../class/broadcaster/add-campaign/show-add-campaign-mode";
import { responseGetExpense } from "../class/http/res/response-get-expense";
import { ExpenseForAdd } from "../interfaces/expense-for-add";
@Component({
    selector: "add-campaign-comp",
    templateUrl: "html/add-campaign.component.html",
    styleUrls: ["css/add-campaign.component.css"],
    providers: [AddCampaign, SingService]
})
export class AddCampaignComponent  {
    expenses: Array<Expense> = [];
    PlannedBudget: number = 0;
    PageLoaded: boolean = false;
    changeSumm: ChangeSumm;
    actualBudgets: number = 0;
    changeTargetBudget:boolean = false;
    CO_OP:number = 0;
    constructor(private broadcaster: Broadcaster, private actions: AddCampaign, private elRef: ElementRef,  private ref: ChangeDetectorRef) { }
    ngOnInit() {

        this.broadcaster.on<any>("showAddCampaignMode").subscribe((data:showAddCampaignMode) => {
            if (data.action === "closed") {
                this.ClosedAll();
                return;
            }
            this.changeTargetBudget = false;
            this.actions.dataId = data.dataId;
            this.PageLoaded = false;
            this.actions.tableData.settings = data.settings;
            this.PlannedBudget = this.actions.summPrice(data.product);
            this.actions.productId = data.productId;
            this.actions.UpdateListProducts = false;
            this.actions.productCategoryId = String(data.productCategoryId).split("categories-").join("");
            this.actions.defaultData = data;
            this.expenses = [];
            this.actualBudgets = 0;
            this.actions.indexProduct = 0;
            this.getExpense(data);
            this.actions.show();
            if (data.action === "ChangeSumm") {
                this.changeSumm = new ChangeSumm(data.Parentproduct, data.productsLen, data.categori);
              
            }
            else {
                this.changeSumm = null;
            }

            this.actions.show();

        });

        this.elRef.nativeElement.querySelector(".add-new-сampaign").addEventListener(
            "click",
            (event) => {
                let expense: Expense = new Expense();
                expense.onInitDefault(this.actions.productId, this.actions.productCategoryId);
               
                this.expenses.push(expense);
                if (this.expenses[0].targetBudgetPercent === 100) {
                    this.expenses[0].targetBudgetPercent = 0;
                }
              
               
            }, false);
      

    }
    
    trackByIndex(index, item) {
        return index;
    }
    removeExpense(index: number) {
    
        if (this.expenses.length === 1) return;
        if (this.expenses[index].id !== 0) {
            this.PageLoaded = false;
            this.actions.removeExpense(this.expenses[index].id)
                .subscribe((res: responseRemoveExpense) => {
                    this.removeExpenseComplite(index);
                    this.actions.AfterremoveExpense(this.actions.dataId, res);
                    this.PageLoaded = true;
                });
        }
        else {
            this.removeExpenseComplite(index);
        }

    }
    removeExpenseComplite(index: number) {
        this.expenses.splice(index, 1);
        if (this.expenses.length === 1) {
            this.expenses[0].targetBudgetPercent = 100;
            if (this.expenses[0].targetBudget === 0)
            {
                this.changeTargetBudget = true;
            }
        }
       
        if (!this.changeSumm)
        {   
      this.actualBudgets = this.actions.summActualBudget(this.expenses);
      this.CO_OP = this.actions.getCOOPSum(this.expenses);
      this.PlannedBudget = this.actions.summTargetBudgets(this.expenses);
        }
        this.broadcaster.broadcast("setblockmask", this.actions.checkExpensesAfterRemove(this.expenses,this.changeSumm,this.PlannedBudget));
      
    }
    onKeyUpActualBudget(e: any,index:number=-1,percent:boolean = false) {
     
            if (percent)
            {
                let actual:number = (this.actualBudgets * (this.expenses[index].actualBudgetPercent / 100));
                this.expenses[index].actualBudget = (this.actualBudgets === 0) ? 0 : this.actions.checkInt(actual) ? actual : this.actions.ceil(actual);
            } else {
                this.actualBudgets = this.actions.summActualBudget(this.expenses);
                this.expenses.forEach((item:Expense) => {
                    item.actualBudgetPercent =  (item.actualBudget === 0) ? 0 : Math.round(item.actualBudget / this.actualBudgets * 100);
              
                })
             }
          
    
    }
  
    onKeyUpTagetBudget(e: any,index:number=-1,percent:boolean = false) {

                    if (percent)
                    {
                        let budget:number = (this.PlannedBudget * (this.expenses[index].targetBudgetPercent / 100));
                        this.expenses[index].targetBudget = (this.PlannedBudget === 0) ? 0 : this.actions.checkInt(budget) ? budget : this.actions.ceil(budget);
                    } else {
                        this.PlannedBudget = this.actions.summTargetBudgets(this.expenses);
                         this.expenses.forEach((item:Expense) => {
                            item.targetBudgetPercent =  (item.targetBudget === 0) ? 0 : Math.round(item.targetBudget / this.PlannedBudget * 100);
                      
                        })
                    }
                    this.expenses.forEach((item:Expense) => {
                        item.coop = (item.targetBudget === 0) ? 0 : Math.round(item.targetBudget * (item.coopPercent / 100));
                  
                  
                    })
                    this.CO_OP = this.actions.getCOOPSum(this.expenses);
                
            
    }
    
    onKeyUpCOOP (e: any,index:number=-1,percent:boolean = false) {
        if (!this.changeSumm)
        {      
            
            if (percent)
            {
               let coop:number = (this.expenses[index].targetBudget * (this.expenses[index].coopPercent / 100));
               this.expenses[index].coop = (this.expenses[index].targetBudget === 0) ? 0 : this.actions.checkInt(coop) ? coop : this.actions.ceil(coop);
                
            } else {
                if (this.expenses[index].coop > this.expenses[index].targetBudget)
                {
                   this.expenses[index].coop = this.expenses[index].targetBudget;
                }
                this.expenses[index].coopPercent =  (this.expenses[index].coop === 0) ? 0 : Math.round(this.expenses[index].coop / this.expenses[index].targetBudget * 100);
               
               }
            this.CO_OP = this.actions.getCOOPSum(this.expenses);
         
        } 
    }
   
     onBlur(e: any) {
        let input = e.target;
        if (input.value === "") {
            input.value = 0;
        }
     //   this.ref.detectChanges();
       
    }
    onKeyUpPlannedTotal(e: any) {
        this.expenses.map((item: Expense) => {
            let budget:number = (item.targetBudgetPercent * this.PlannedBudget / 100);
            let coop:number = (item.targetBudget * (item.coopPercent / 100));
            if (this.expenses.length === 1)
            {
                item.targetBudget = this.PlannedBudget;
            } else {
                item.targetBudget = (this.PlannedBudget === 0) ? 0 : this.actions.checkInt(budget) ? budget : this.actions.ceil(budget);
            }
           item.coop = (item.targetBudget === 0) ? 0 : this.actions.checkInt(coop) ? coop : this.actions.ceil(coop);
      
           return item;
       });
       this.CO_OP = this.actions.getCOOPSum(this.expenses);
     
    }
    onKeyUpActualTotal(e: any) {
        this.expenses.map((item: Expense) => {
            let actual:number = (item.actualBudgetPercent * this.actualBudgets / 100);
           item.actualBudget = (this.actualBudgets === 0) ? 0 : this.actions.checkInt(actual) ? actual : this.actions.ceil(actual);
           return item;
       })
    }
    
  
    getExpense(data: showAddCampaignMode, resetActual: boolean = false) {
        this.actions.getExpense(data.product[this.actions.indexProduct].expenses[0].id)
            .subscribe((res: responseGetExpense) => {
               
                let coopPercent: number = Number(res.expense.coop / res.expense.targetBudget * 100);
                coopPercent = (coopPercent !== NaN) ? coopPercent : 0;
                if (coopPercent > 0)
                {
                    res.expense.coopPercent = (this.actions.checkInt(coopPercent)) ? coopPercent : this.actions.ceil(coopPercent);
                } else {
                    res.expense.coopPercent = 0;
                }
                
                let targetBudgetPercent: number = Number(res.expense.targetBudget / this.PlannedBudget * 100);
                res.expense.targetBudgetPercent = (this.actions.checkInt(targetBudgetPercent)) ? targetBudgetPercent : this.actions.ceil(targetBudgetPercent);
               
                if (data.product.length === 1 || data.product.length === 0) {
                    res.expense.targetBudgetPercent = 100;
                    res.expense.actualBudgetPercent =  100;
      
                }
                res.expense.budget = res.expense.targetBudget;
                if (resetActual) {
                    res.expense.actualBudget = 0;
                    res.expense.actualBudgetPercent =  0;
                    res.expense.campaign = "";
                }
                this.expenses.push(res.expense);
                if (this.expenses.length !== data.product.length) {
                    this.actions.indexProduct++;
                    this.getExpense(data, resetActual);
                }
                else {
                    this.PageLoaded = true;

                    this.PlannedBudget = this.actions.summBudgets(this.expenses);
                    this.actualBudgets = this.actions.summActualBudget(this.expenses);
                  this.CO_OP = this.actions.getCOOPSum(this.expenses);

                    if (this.changeSumm) {
                      //  this.changeSumm.actualBudgets = this.actions.summActualBudget(this.expenses);
                        this.expenses.map((item: Expense) => {
                            item.actualBudgetPercent = (this.actualBudgets === 0) ? 0 : (Math.round(item.actualBudget / this.actualBudgets * 100));
                            return item;
                        })
                    } else {
                        this.expenses.map((item: Expense) => {
                            item.actualBudgetPercent = (this.actualBudgets === 0) ? 0 : (Math.round(item.actualBudget / this.actualBudgets * 100));
                            return item;
                        })
                    }
                    
                   
                }
            });

    }
    ClosedAll() {

        if (this.elRef.nativeElement.querySelector(".modal-add-product").style.display === "block") {
            this.PageLoaded = false;
            this.actions.CloseAll();
        }

    }
    Save() {
        let errorCampaign: boolean = false;
        let targetBudgetPercent: number = 0;
        let targetBudget: number = 0;
        let actualBudgetPercent: number = 0;
      
        for (let i = 0; i < this.expenses.length; i++) {
            
   
            targetBudgetPercent += this.expenses[i].targetBudgetPercent;
            actualBudgetPercent += this.expenses[i].actualBudgetPercent;
            targetBudget += this.expenses[i].targetBudget;
            if (this.expenses[i].campaign === "") {
                errorCampaign = true;
            }
            if (targetBudgetPercent > 100 && (i + 1) !== this.expenses.length) {
                this.actions.showErrorAlert("The percent of the budget should be exactly 100%");
                return;
            }
            for (let u = (i + 1); u < this.expenses.length; u++) {
                if (this.expenses[i].campaign === this.expenses[u].campaign) {
                    this.actions.showErrorAlert("The names of companies can not be the same");
                    return;
                }

            }
        }
        if (targetBudget !== this.PlannedBudget) {
            this.actions.showErrorAlert("The percent of the budget should be exactly 100%");
            return;
        }
        if (targetBudgetPercent !== 100) {
            this.actions.showErrorAlert("The percent of the budget should be exactly 100%");
            return;
        }
        if (errorCampaign) {
            this.actions.showErrorAlert("Add the name of the campaign");
            return;
        }

        this.actions.indexExpense = 0;
        if (this.changeSumm) {
            if (actualBudgetPercent === 0) {
                this.expenses.map((item) => {
                    item.actualBudgetPercent = item.targetBudgetPercent;
                    return item;
                })
                actualBudgetPercent = 100;
            }
            if (actualBudgetPercent !== 100) {
                this.actions.showErrorAlert("The percent of the actual budget should be exactly 100%");
                return;
            }
            this.PageLoaded = false;
            let data: SummExpense = new SummExpense(this.actions.tableData.settings.year, this.actions.tableData.settings.month,
                this.actions.tableData.settings.dealerShipId, String(this.changeSumm.product.id).split("products-").join(""),
                this.PlannedBudget, this.actualBudgets, this.expenses);

            this.actions.setSummExpense(data)
                .subscribe((data: responseUpdateExpensesProduct) => {
                    this.actions.AfterUpdateSummExpenses(data, this.changeSumm);
                    this.UpdateExpense();
                });
            return;
        }
        this.UpdateExpense();
        this.PageLoaded = false;

    }

    UpdateExpense() {

        let data: Expense = this.actions.getExpenseForUpdate(this.expenses[this.actions.indexExpense]);
        if (this.changeSumm) {
            delete data.targetBudget;
            delete data.actualBudget;
        }

        if (this.expenses[this.actions.indexExpense].campaign === "") {
            this.PageLoaded = true;
            return;
        };

        if (this.expenses[this.actions.indexExpense].id !== 0) {
            this.actions.saveExpense(data)
                .subscribe((data: responseSaveExpense) => {
                    this.actions.indexExpense++;
                    if (this.actions.indexExpense !== this.expenses.length) {
                        this.UpdateExpense();
                    }
                    else {
                        this.compliteSaveExpense();
                    }
                });
        }
        else {
            this.addExpense();
        }

    }
    compliteSaveExpense() {
        this.broadcaster.broadcast("setblockmask", false);
        this.ClosedAll();
        this.actions.compliteSaveExpense(this.actions.dataId);
    }
    addExpense() {
        if (this.expenses.length === 1 && this.expenses[0].id === 0)
        {
            this.expenses[0].targetBudget = this.PlannedBudget;
        }
        let data: ExpenseForAdd = this.actions.getExpenseForAdd(this.expenses[this.actions.indexExpense], this.actions.tableData);
        this.actions.addExpense(data)
            .subscribe((res: responseAddExpense) => {

                this.actions.UpdateListProducts = true;
                this.actions.indexExpense++;
                if (this.actions.indexExpense !== this.expenses.length) {
                    this.UpdateExpense();
                }
                else {
                    this.compliteSaveExpense();
                }
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/add-campaign/add-campaign.component.ts